module.exports = __webpack_public_path__ + "static/media/7.a9d0a8dc.mp3";